import TwoWindingTransformers from "../classes/TwoWindingTransformer";

export const twoWindingTransformers = [
  new TwoWindingTransformers({
    alias: "transfomador-de-2-devanados-Base",
    svgSrc: "/symbol-assets/TransformadorDosDevanadosBase.svg",
    label: "2 devanados",
    rotable: true,
    variants: [
      {
        alias: "transfomador-de-2-devanados-Base",
        diagramSvgSrc: "/symbol-assets/TransformadorDosDevanadosBase.svg",
        label: "",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-DeltaDelta",
        diagramSvgSrc: "/symbol-assets/TransformadorDevanadosConectadoDeltaDelta.svg",
        label: "Delta-Delta",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-DeltaEstrella",
        diagramSvgSrc: "/symbol-assets/TransformadorDevanadosConectadoDeltaEstrella.svg",
        label: "Delta-Estrella",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-DeltaEstrella-Aterrizado",
        diagramSvgSrc: "/symbol-assets/TransformadorDevanadosConectadoDeltaEstrella-Aterrizado.svg",
        label: "Delta-Estrella-Aterrizado",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-EstrellaEstrella",
        diagramSvgSrc: "/symbol-assets/Transformador2DevanadosConectadoEstrellaEstrella.svg",
        label: "Estrella-Estrella",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-Impedancia",
        diagramSvgSrc: "/symbol-assets/TransformadorDe2DevanadosDeltaEstrellaConImpedancia.svg",
        label: "Delta-Estrella con Impedancia",
        selected: false
      },
      {
        alias: "transfomador-de-2-devanados-ImpedanciaB", diagramSvgSrc: "/symbol-assets/TransformadorDe2DevanadosDeltaEstrellaConImpedanciaB.svg", label: "Delta-Estrella con Impedancia B", selected: false
      },
      {
        alias: "transfomador-de-2-devanados-IEC-DeltaDelta", diagramSvgSrc: "/symbol-assets/IECTransformador2DevanadosConectadoDeltaDelta.svg", label: "IEC Delta-Delta", selected: false
      },
      {
        alias: "transfomador-de-2-devanados-IEC-DeltaEstrella", diagramSvgSrc: "/symbol-assets/IECTransformador2DevanadosConectadoDeltaEstrella.svg", label: "IEC Delta-Estrella", selected: false
      },
      {
        alias: "transfomador-de-2-devanados-IEC-EstrellaEstrella", diagramSvgSrc: "/symbol-assets/IECTransformador2DevanadosConectadoEstrellaEstrella.svg", label: "IEC Estrella-Estrella", selected: false
      }
    ]
  })
];
